export const SIZE_XSMALL = 'xs'
export const SIZE_SMALL = 'sm'
export const SIZE_MEDIUM = 'md'
export const SIZE_LARGE = 'lg'
export const SIZE_XLARGE = 'xl'
export const SIZE_2XLARGE = '2xl'

export const SIZES = {
  [SIZE_XSMALL]: 'XSmall',
  [SIZE_SMALL]: 'Small',
  [SIZE_MEDIUM]: 'Medium',
  [SIZE_LARGE]: 'Large',
  [SIZE_XLARGE]: 'XLarge',
  [SIZE_2XLARGE]: '2XLarge',
}

export const VARIANT_PRIMARY = 'primary'
export const VARIANT_INFO = 'info'
export const VARIANT_SUCCESS = 'success'
export const VARIANT_DARK = 'dark'
export const VARIANT_LIGHT = 'light'
export const VARIANT_SECONDARY = 'secondary'
export const VARIANT_PLAIN = 'plain'
export const VARIANT_NOTIFY = 'notify'

export const VARIANT_BLUE = 'blue'
export const VARIANT_RED = 'red'

export const VARIANTS = {
  [VARIANT_PRIMARY]: 'Primary',
  [VARIANT_INFO]: 'Info',
  [VARIANT_SUCCESS]: 'Success',
  [VARIANT_DARK]: 'Dark',
  [VARIANT_LIGHT]: 'Light',
  [VARIANT_SECONDARY]: 'Secondary',
  [VARIANT_PLAIN]: 'Plain',
  [VARIANT_NOTIFY]: 'Notify'
}
